import GraphicEqIcon from '@mui/icons-material/GraphicEq';
import ViewListOutlinedIcon from '@mui/icons-material/ViewListOutlined';

const SuperAdminMenus = [
    {
        label: 'sidebar.menu.home',
        type: "section",
        children: [
            {
                uri: "/superadmin/apps",
                label: 'sidebar.menuItem.misc',
                type: "nav-item",
                icon: <GraphicEqIcon sx={{fontSize: 20}}/>
            },
            {
        
                uri: "/superadmin/tenants",
                label: 'sidebar.menuItem.projects',
                type: "nav-item",
                icon: <ViewListOutlinedIcon sx={{fontSize: 20}}/>
            }

        ]
    },   
            
    
];

export default SuperAdminMenus;
